import { defineStore } from 'pinia'
import { sacredAxios } from "@services/sacred-axios";

export const useFlameStore = defineStore('flame', {
    state: () => ({
        flameIdentity: null,
        flameToken: null,
        initialized: false,
    }),

    getters: {
        isRemembered(state) {
            // This stays intentionally vague.
            // Later this could check presence of user, email, claim, etc.
            return !!state.flameIdentity?.remembered_at
        },

        hasFlame(state) {
            return !!state.flameIdentity
        },
    },

    actions: {
        async initialize() {
            if (this.initialized) return

            const flameTokenKey = 'flame-token'
            let token = localStorage.getItem(flameTokenKey)
            if (!token) {
                token = crypto.randomUUID()
                localStorage.setItem(flameTokenKey, token)
            }
            this.flameToken = token

            const { success, error, data } = await sacredAxios('/flame/initialize', {})

            if (success) {
                this.flameIdentity = data.flame_identity
                this.initialized = true
            } else {
                console.warn('🔥 Flame initialization failed.', error)
            }
        },

        setFlameIdentity(identity) {
            this.flameIdentity = identity
        },

        setFlameToken(token) {
            localStorage.setItem('flame-token', token)
            this.flameToken = token
        },

        clearFlame() {
            this.flameIdentity = null
            this.flameToken = null
            this.initialized = false
        },
    },
})
